import { ApplicantProfileMenuService } from './applicant-profile-menu.service';
import { JobPostingMenuService } from './job-posting-menu.service';
import { RecruitingModuleMenuService } from './recruiting-module-menu.service';

export const MenuServices = [ApplicantProfileMenuService, JobPostingMenuService, RecruitingModuleMenuService];
